export default {
  install (Vue, options) {
    // console.log('Installing GMP_DataViz paginationPlugin...')
    Vue.prototype.$paginationPlugin = {
      /*
       * vrati hash s nastavenou settings 'pagination'
       * @param {String} hash - hash
       * @param {Number} page - cislo strany
       * @returns {String}
       */
      changePage: function (hash, page) {
        let filtersHash = hash.substr(1).split('|')[0]
        let settingsArr = Vue.prototype.$hashPlugin.stringToArray(hash.substr(1).split('|')[1], 'settings')
        settingsArr.find(setting => setting.settingCode === 'pagination').settingValue = page
        let newHash = '#' + filtersHash + '|' + Vue.prototype.$hashPlugin.arrayToString(settingsArr, 'settings')
        return newHash
      },

      /*
       * vrati hash s nastavenou settings 'rows_per_page'
       * @param {String} hash - hash
       * @param {Number} page - cislo strany
       * @returns {String}
       */
      changeRowsPerPage: function (hash, rowsPerPage) {
        let filtersHash = hash.substr(1).split('|')[0]
        let settingsArr = Vue.prototype.$hashPlugin.stringToArray(hash.substr(1).split('|')[1], 'settings')
        settingsArr.find(setting => setting.settingCode === 'rows_per_page').settingValue = rowsPerPage
        settingsArr.find(setting => setting.settingCode === 'pagination').settingValue = 1
        let newHash = '#' + filtersHash + '|' + Vue.prototype.$hashPlugin.arrayToString(settingsArr, 'settings')
        return newHash
      },

      /*
      * vrati 'rows_per_page'
      * @param {Array} settingsArr - pole settings
      * @returns {Object, Number}
      */
      setRowsPerPage: function (settingsArr) {
        let rowsPerPage
        if (!settingsArr.find(setting => setting.settingCode === 'rows_per_page')) {
          rowsPerPage = {
            settingCode: 'rows_per_page',
            settingValue: process.env.VUE_APP_ROWS_PER_PAGE
          }
        } else {
          rowsPerPage = Number(settingsArr.find(setting => setting.settingCode === 'rows_per_page').settingValue)
        }
        return rowsPerPage
      },
      /*
      * vrati 'pagination'
      * @param {Array} settingsArr - pole settings
      * @returns {Object, Number}
      */
      setPagiantion: function (settingsArr) {
        let pagination
        if (!settingsArr.find(setting => setting.settingCode === 'pagination')) {
          pagination = {
            settingCode: 'pagination',
            settingValue: 1
          }
        } else {
          pagination = Number(settingsArr.find(setting => setting.settingCode === 'pagination').settingValue)
        }
        return pagination
      },
      /*
       * vrati cislo strany, bud 1 nebo z hashe
       * @param {String} settingsHash - settings z hashe
       * @return {Number}
       */
      getPagination: function (settingsHash) {
        let settingsArr = Vue.prototype.$hashPlugin.stringToArray(settingsHash, 'settings')
        let page = 0
        if (settingsArr.some(setting => setting.settingCode === 'pagination')) {
          page = Number(settingsArr.find(setting => setting.settingCode === 'pagination').settingValue)
        } else {
          page = 1
        }
        return page
      },
      /*
       * vrati rowsPerPage, bud process.env nebo z hashe
       * @param {String} settingsHash - settings z hashe
       * @return {Number}
       */
      getRowsPerPage: function (settingsHash) {
        let settingsArr = Vue.prototype.$hashPlugin.stringToArray(settingsHash, 'settings')
        let rowsPerPage = 0
        if (settingsArr.some(setting => setting.settingCode === 'rows_per_page')) {
          rowsPerPage = Number(settingsArr.find(setting => setting.settingCode === 'rows_per_page').settingValue)
        } else {
          rowsPerPage = process.env.VUE_APP_ROWS_PER_PAGE
        }
        return rowsPerPage
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/paginationPlugin.js